import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';

const CategoryList = ({ categories: { nodes } }) => {
  return (
    <section className="post-single__categories">
      <h2 className="categories__title">Want to dig deeper?</h2>
      <ul className="categories__list">
        {nodes.map(({ name, urlPath }) => {
          return (
            <li className="categories__list-item" key={urlPath}>
              <Link className="categories__link pill-button small" to={urlPath}>
                <div className="visuallyHidden">Category:</div>
                {name}
              </Link>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

CategoryList.propTypes = {
  categories: PropTypes.shape({
    nodes: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        urlPath: PropTypes.string,
      })
    ),
  }).isRequired,
};

export default CategoryList;
